// @mui

import { mapVisitStatusToString } from 'src/utils/mapVisitStatusToString';
import {
  GetVisitByIdRejectedByEnum,
  GetVisitByIdStatusEnum,
} from 'woofwoof-api';
import Iconify from '../iconify';
import Label from '../label';
// ----------------------------------------------------------------------

interface VisitStatusBadgeProps {
  visitStatus?: GetVisitByIdStatusEnum;
  // Pass `rejectedBy` so a system-rejected visit can be labelled distinctly
  // ("Odrzucona przez system") even though it shares `status: REJECTED` with
  // owner-rejected ones.
  rejectedBy?: GetVisitByIdRejectedByEnum;
}

export default function VisitStatusBadge({
  visitStatus,
  rejectedBy,
}: VisitStatusBadgeProps) {
  if (!visitStatus) {
    return null;
  }

  const statusInfo = mapVisitStatusToString(visitStatus, rejectedBy);

  if (!statusInfo) {
    return null;
  }

  return (
    <Label
      variant="soft"
      color={statusInfo.color}
      sx={{ textTransform: 'none', width: 'fit-content' }}
      startIcon={<Iconify icon={statusInfo.icon || ''} />}
    >
      {statusInfo.label}
    </Label>
  );
}
